import { FC, ReactNode } from 'react';
import { DrawerProps as MuiDrawerProps, Drawer as MuiDrawer } from '@mui/material';
import { Content, DrawerHeader } from './Drawer.styles';
import { Button } from '../button';
import { Close } from '@mui/icons-material';

interface DrawerProps {
	open: boolean;
	setOpen: (open: boolean) => void;
	anchor?: MuiDrawerProps['anchor'];
	title: ReactNode;
	children: ReactNode;
}

const Drawer: FC<DrawerProps> = ({ open, setOpen, anchor, title, children }) => {
	return (
		<MuiDrawer open={open} onClose={() => setOpen(false)} anchor={anchor}>
			<Content>
				<DrawerHeader>
					<span>{title}</span>
					<Button
						variant='icon'
						icon={<Close fontSize='inherit' />}
						onClick={() => setOpen(false)}
					/>
				</DrawerHeader>
				{children}
			</Content>
		</MuiDrawer>
	);
};

export default Drawer;
